import {m} from '@codeurs/front'
import InnerHTML from 'dangerously-set-html-content'
import {FunctionComponent} from 'react'
import {useLanguage} from 'util/i18n'
import {style} from 'util/style'
import {Block} from 'views/blocks/blocks'

const styles = style('matomo')

export const MatomoBlock: FunctionComponent = () => {
  const lang = useLanguage()

  return (
    <Block class={styles}>
      <InnerHTML
        html={`<iframe height="200" width="600" src="https://analytics.klimaat.be/index.php?module=CoreAdminHome&action=optOut&language=${lang}&fontFamily=Arial,+Helvetica,+sans-serif" aria-label="Matomo"/>`}
      />
    </Block>
  )
}
